import React from 'react';
import ReactDOM from 'react-dom';
import './App.css'; // Ensure you import your App.css
import './global.css'; // Import the global CSS
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
